export const PAGE_NAME_TEMPLATE = '__PAGE_NAME__';
